<button mat-button class="ca-button ca-button-xs ms-auto md:my-auto calculation-base" (click)="openDrawer()">
    <ca-icon icon="settings" class="ca-icon-s"></ca-icon><span>{{ 'RBR.BUTTON.CALCULATION_BASE' | translate }}</span>
</button>

<ca-drawer #drawer overriddenWidth="664px" [bodyBordered]="true">
    <h2 drawer-header class="ca-headline-2 ca-bold m-0">{{ headerText() | translate }}</h2>
    <div drawer-body class="pt-4">
        <form [formGroup]="form" class="calculation-base-form flex flex-col">
            <p class="m-0 calculation-base-helper-text">{{ 'RBR.CALCULATION_BASE.SELECTION_HINT' | translate }}</p>
            <h3 class="ca-headline-3 ca-bold m-0">{{ 'RBR.CALCULATION_BASE.PLAN_HEATING_AND_COOLING' | translate }}</h3>

            <div class="flex items-start gap-3">
                <ca-toggle
                    [value]="form.controls.includeTotalBuilding.value"
                    (valueChanged)="form.controls.includeTotalBuilding.setValue($event)"
                ></ca-toggle>
                <div class="flex flex-col gap-1">
                    <div class="ca-text-lg">{{ 'RBR.CALCULATION_BASE.INCLUDE_TOTAL_BUILDING' | translate }}</div>
                    <div class="ca-text-sm">{{ 'RBR.CALCULATION_BASE.UNASSIGNED_AREA_HELPER_TEXT' | translate }}</div>
                </div>
            </div>

            <div class="flex items-start gap-3">
                <div class="w-10 shrink-0" aria-hidden="true"></div>
                <div class="flex flex-col gap-2">
                    <mat-form-field
                        appearance="outline"
                        floatLabel="always"
                        class="ca-form-field ca-form-field-xs ca-form-field-w-120 living-area-field with-label with-error-message"
                    >
                        <mat-label>{{ 'RBR.CALCULATION_BASE.TOTAL_LIVING_AREA' | translate }}</mat-label>
                        <input
                            matInput
                            formControlName="totalLivingArea"
                            [attr.aria-label]="'RBR.CALCULATION_BASE.TOTAL_LIVING_AREA' | translate"
                            placeholder="0"
                            [mask]="mask.pattern"
                            [decimalMarker]="mask.decimalMarker!"
                            [separatorLimit]="mask.separatorLimit!"
                            [suffix]="mask.suffix!"
                        />
                        @if (hasError('totalLivingArea', 'required')) {
                            <mat-error>
                                <ca-form-error-message>
                                    {{ 'RBR.CALCULATION_BASE.ERROR_TOTAL_LIVING_AREA_REQUIRED' | translate }}
                                </ca-form-error-message>
                            </mat-error>
                        }

                        @if (hasError('totalLivingArea', 'invalidTotalLivingArea')) {
                            <mat-error>
                                <ca-form-error-message>
                                    {{ 'RBR.CALCULATION_BASE.ERROR_INVALID_TOTAL_LIVING_AREA' | translate }}
                                </ca-form-error-message>
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    <button drawer-footer mat-stroked-button class="ca-button ca-button-m" (click)="onCancel()">
        <span>{{ 'CA.BUTTON.CANCEL' | translate }}</span>
    </button>
    <button drawer-footer mat-flat-button class="ca-button ca-button-m" [disabled]="form.invalid" (click)="onConfirm()">
        <span>{{ 'CA.BUTTON.CONFIRM' | translate }}</span>
    </button>
</ca-drawer>
